import _slicedToArray from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import useMergedRefs from '@restart/hooks/useMergedRefs';
import useEventCallback from '@restart/hooks/useEventCallback';
import useIsomorphicEffect from '@restart/hooks/useIsomorphicEffect';
import React, { useRef, cloneElement, useState } from 'react';
import NoopTransition from './NoopTransition';
import { jsx as _jsx } from "react/jsx-runtime";
export function useTransition(_ref) {
  var inProp = _ref.in,
    onTransition = _ref.onTransition;
  var ref = useRef(null);
  var isInitialRef = useRef(true);
  var handleTransition = useEventCallback(onTransition);
  useIsomorphicEffect(function () {
    if (!ref.current) {
      return undefined;
    }
    var stale = false;
    handleTransition({
      in: inProp,
      element: ref.current,
      initial: isInitialRef.current,
      isStale: function isStale() {
        return stale;
      }
    });
    return function () {
      stale = true;
    };
  }, [inProp, handleTransition]);
  useIsomorphicEffect(function () {
    isInitialRef.current = false;
    // this is for strict mode
    return function () {
      isInitialRef.current = true;
    };
  }, []);
  return ref;
}
/**
 * Adapts an imperative transition function to a subset of the RTG `<Transition>` component API.
 *
 * ImperativeTransition does not support mounting options or `appear` at the moment, meaning
 * that it always acts like: `mountOnEnter={true} unmountOnExit={true} appear={true}`
 */
export default function ImperativeTransition(_ref2) {
  var children = _ref2.children,
    inProp = _ref2.in,
    onExited = _ref2.onExited,
    onEntered = _ref2.onEntered,
    transition = _ref2.transition;
  var _useState = useState(!inProp),
    _useState2 = _slicedToArray(_useState, 2),
    exited = _useState2[0],
    setExited = _useState2[1]; // TODO: I think this needs to be in an effect
  if (inProp && exited) {
    setExited(false);
  }
  var ref = useTransition({
    in: !!inProp,
    onTransition: function onTransition(options) {
      var onFinish = function onFinish() {
        if (options.isStale()) return;
        if (options.in) {
          onEntered == null ? void 0 : onEntered(options.element, options.initial);
        } else {
          setExited(true);
          onExited == null ? void 0 : onExited(options.element);
        }
      };
      Promise.resolve(transition(options)).then(onFinish, function (error) {
        if (!options.in) setExited(true);
        throw error;
      });
    }
  });
  var combinedRef = useMergedRefs(ref, children.ref);
  return exited && !inProp ? null : /*#__PURE__*/cloneElement(children, {
    ref: combinedRef
  });
}
export function renderTransition(Component, runTransition, props) {
  if (Component) {
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
  }
  if (runTransition) {
    return /*#__PURE__*/_jsx(ImperativeTransition, Object.assign({}, props, {
      transition: runTransition
    }));
  }
  return /*#__PURE__*/_jsx(NoopTransition, Object.assign({}, props));
}